export enum WarehouseGoodType {
  Accessories = 'ACCESSORIES',
  Box = 'BOX',
  Cosmetic = 'COSMETIC',
  Product = 'PRODUCT',
}
